"use client";
import React from "react";
import { Modal, Box, Stack, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ActionModal = ({
  open,
  onClose,
  title = "Action",
  width = 450,
  children,
  actions, // footer buttons
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width,
          bgcolor: "white",
          p: 3,
          borderRadius: 2,
          boxShadow: 24,
        }}
      >
        {/* Header */}
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography sx={{ fontSize: "20px", fontWeight: "bold" }}>
            {title}
          </Typography>

          <IconButton onClick={onClose} sx={{ color: "red" }}>
            <CloseIcon />
          </IconButton>
        </Stack>

        {/* Body */}
        <Box sx={{ mt: 2 }}>{children}</Box>

        {/* Footer */}
        {actions && (
          <Box sx={{ display: "flex", justifyContent: "end", mt: 3 }}>{actions}</Box>
        )}
      </Box>
    </Modal>
  );
};

export default ActionModal;
